<template>
	<v-container fluid class="pb-2">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="d-flex justify-left align-center pa-2 pb-0">
									{{ $t('titles.preregistrated') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="candidatesPreregistrationsTable.additionalFilters"
									:default-sort="candidatesPreregistrationsTable.defaultSort"
									:excel="false"
									:show-pagination="false"
									:fields="candidatesPreregistrationsTable.headers"
									:header-selection-key="'preregistrations-candidates-headers'"
									:height="candidatesPreregistrationsTable.height"
									:total-records="candidatesPreregistrationsTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in candidatesPreregistrationsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="redirectClick(props.item.id, true)"
									>
										<td
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('rbr')"
											@click="redirectClick(item.id, false)"
										>
											{{ key + 1 }}
										</td>
										<td
											v-if="
												candidatesPreregistrationsTable.selectedHeaders.includes('first_name')
											"
											@click="redirectClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.first_name : item.first_name }}
										</td>
										<td
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('last_name')"
											@click="redirectClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.last_name : item.last_name }}
										</td>
										<td
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('email')"
											@click="redirectClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.email : item.email }}
										</td>
										<td
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('phone')"
											@click="redirectClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.phone : item.phone }}
										</td>
										<td
											v-if="
												candidatesPreregistrationsTable.selectedHeaders.includes('partner_id')
											"
											@click="redirectClick(item.id, false)"
										>
											{{
												item.candidate_id
													? item.candidate.partner_id
														? item.candidate.partner.name
														: '-'
													: item.partner_id
													? item.partner.name
													: '-'
											}}
										</td>
										<td
											v-if="
												candidatesPreregistrationsTable.selectedHeaders.includes(
													'login_type_id'
												)
											"
											@click="redirectClick(item.id, false)"
										>
											{{ item.login_type_id ? item.login_type.name : '' }}
										</td>
										<td
											v-if="
												candidatesPreregistrationsTable.selectedHeaders.includes('loyalty_card')
											"
											@click="redirectClick(item.id, false)"
										>
											{{ item.candidate ? item.candidate.loyalty_card : '' }}
										</td>
										<td
											class="truncate-note"
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('note')"
											@click="redirectClick(item.id, false)"
										>
											{{ item.note }}
										</td>
										<td
											v-if="candidatesPreregistrationsTable.selectedHeaders.includes('notified')"
											@click="redirectClick(item.id, false)"
										>
											<v-icon v-if="item.notified" small>fa-check</v-icon>
										</td>
										<td
											v-if="
												canEdit && item.candidate_id != null && item.planned_course_id != null
											"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														v-on="on"
														@click="
															enrollCandidate(
																item.id,
																item.first_name + ' ' + item.last_name,
																item.candidate_id
															)
														"
													>
														<v-icon small>fas fa-user-plus</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.enrollCandidate') }}</span>
											</v-tooltip>
										</td>
										<td v-if="canEdit && item.candidate_id == null">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														color="basicButton"
														v-bind="attrs"
														v-on="on"
														@click="addToTheBaseClick(item)"
													>
														{{ $t('buttons.addToTheBase') }}
													</v-btn>
												</template>
												<span>{{ $t('tooltips.enrollCandidate') }}</span>
											</v-tooltip>
										</td>
										<td
											v-if="
												canEdit && item.candidate_id != null && item.planned_course_id == null
											"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon v-bind="attrs" v-on="on" @click="addPlan(item.id)">
														<v-icon small>fas fa-circle-exclamation</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.addPlannedCourse') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="showModal">
			<v-col>
				<Modal :show-modal="showModal">
					<CandidatePaymentContract
						:preregistrationId="preregistrationId"
						:candidateFullName="candidateFullName"
						:candidateId="candidateId"
						@close="closeModal"
					></CandidatePaymentContract>
				</Modal>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<Modal :show-modal="showModalNewCandidate">
					<NewCandidate :newCandidate="newCandidate" :inEditMode="true" @close="closeModal"></NewCandidate>
				</Modal>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import CandidatePaymentContract from './CandidatePaymentContract';
import NewCandidate from './NewCandidate';
import Candidate from '../../../models/Candidate';

export default {
	name: 'CandidatesPreregistrations',
	components: { TheTable, Modal, CandidatePaymentContract, NewCandidate },
	props: {
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	emits: ['reloadParticipants', 'reloadCandidatesRegistrations', 'reloadPlannedCourse'],
	data: function () {
		return {
			candidatesPreregistrationsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.rbr'),
						value: 'rbr',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.firstName'),
						value: 'first_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.lastName'),
						value: 'last_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.email'), value: 'email', type: '', sortable: false, allowFilter: true },
					{ text: this.$t('fields.phone'), value: 'phone', type: '', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.company'),
						value: 'partner_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.loginType'),
						value: 'login_type_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.loyaltyCard'),
						value: 'loyalty_card',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.note'), value: 'note', type: '', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.notified'),
						value: 'notified',
						type: '',
						width: '100px',
						sortable: false,
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			candidateFullName: null,
			candidateId: null,
			preregistrationId: null,
			showModal: false,
			showModalNewCandidate: false,
			newCandidate: new Candidate({ id: 0 }),
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidatesPreregistrationsTable.selectedHeaders = headers;
		},
		redirectClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/preregistrations/' + id);
			} else {
				let routeData = this.$router.resolve('/preregistrations/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		addToTheBaseClick(candidate) {
			candidate.preregistration_id = candidate.id;
			this.newCandidate = new Candidate(candidate);
			this.showModalNewCandidate = true;
		},
		closeModal() {
			this.showModal = false;
			this.showModalNewCandidate = false;
		},
		backClick() {
			this.$router.go(-1);
		},
		addPlan(id) {
			let vm = this;
			this.$verify(this.$t('alerts.registrationOnThisCourse'), (result) => {
				if (result) {
					this.$APICall(
						'put',
						'preregistrations/enrollment/' + id,
						{
							enrollment: true,
							user_id: this.$myStore.state.user.id,
							planned_course_id: this.$route.params.id,
						},
						(data, success) => {
							if (success) {
								if (data == 409) {
									vm.$alert(vm.$t('alerts.candidateAlreadyEnrolled'));
									this.$emit('close');
									return;
								}

								if (data == 422) {
									vm.$alert(vm.$t('alerts.candidateAlreadyHavePaymentContract'));
									this.$emit('close');
									return;
								}
								vm.$notify(vm.$t('alerts.basicUpdate'));
								vm.$modalBus.$emit('reloadParticipants');
								vm.$modalBus.$emit('reloadPlannedCourse');
								vm.$modalBus.$emit('reloadCandidatesRegistrations');
								vm.$modalBus.$emit('reloadCandidatesPreregistrations');
							} else {
								if (Object.hasOwn(data, 'custom')) {
									vm.$alert(data.message);
									this.$router.go(-1);
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
							this.$emit('close');
						}
					);
				} else {
					this.$verify(this.$t('alerts.addPlannedCourseToPreregistredCandidate'), (result) => {
						if (result) {
							this.$APICall(
								'put',
								'preregistrations/plan/' + id,
								{ planned_course_id: this.$route.params.id },
								(data, success) => {
									if (data == 409) {
										vm.$alert(vm.$t('alerts.candidateAlreadyHavePlannedCourse'));
										return;
									}
									if (data == 404) {
										vm.$alert(vm.$t('alerts.preregistrationNotFound'));
										return;
									}
									if (success) {
										vm.$notify(vm.$t('alerts.basicUpdate'));
										vm.$modalBus.$emit('reloadPlannedCourse');
										vm.$modalBus.$emit('reloadCandidatesPreregistrations');
									} else {
										if (Object.hasOwn(data, 'custom')) {
											vm.$alert(data.message);
											vm.backClick();
										} else {
											vm.$alert(vm.$t('alerts.basicError'));
										}
									}
								}
							);
						}
					});
				}
			});
		},
		enrollCandidate(preregistrationId, candidateFullName, candidateId) {
			this.showModal = true;
			this.candidateFullName = candidateFullName;
			this.preregistrationId = preregistrationId;
			this.candidateId = candidateId;
		},
		reloadData(request) {
			this.candidatesPreregistrationsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'preregistrations-candidates/' + this.plannedCourseId,
				request,
				(data, success) => {
					if (success) {
						vm.candidatesPreregistrationsTable.items = data.items;
						vm.candidatesPreregistrationsTable.total = data.total;
					} else {
						if (Object.hasOwn(data, 'custom')) {
							vm.$alert(data.message);
							this.$router.go(-1);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidatesPreregistrationsTable.height = '500px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadCandidatesPreregistrations', () => {
			vm.reloadData(vm.candidatesPreregistrationsTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
